import * as React from "react"
import arrowUpImage from "../static/assets/images/arrow-up.svg"
import arrowDownImage from "../static/assets/images/arrow-down.svg"
import {useTranslation} from "gatsby-plugin-react-i18next";

const ShowAllParametersButton = (props) => {
const { t } = useTranslation();
    
return(
    <div className="show-params mt-2" >
        <button className="btn primary-btn py-3 px-5" onClick={props.onClick}>
            {props.value &&
                <>
                    <span className="me-2">{t("show-all-parameters")}</span>
                    <img className="show-icon" src={arrowUpImage} alt="arrow"/>
                </>}
            {!props.value &&
                <>
                    <span className="me-2">{t("hide-all-parameters")}</span>
                    <img className="show-icon" src={arrowDownImage} alt="arrow"/>
                </>}
        </button>
    </div>
)
}

export default ShowAllParametersButton;